<template>
  <v-app class="cont">
    <top-nav v-if="user"/>
    <v-content>
      <v-container fluid>
        <router-view></router-view>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import TopNav from "./components/TopNav";
export default {
  created() {
    setTimeout(() => {
      let error = {message: "Your session has expired!"}
      this.$store.commit("setError", error);
      this.$store.commit("clearUser");
      this.$router.replace("/signin")
    }, 1800000);
  },
  components: {
    topNav: TopNav
  },
  computed: {
    user() {
      return this.$store.getters.getUser;
    }
  }
};
</script>

<style scoped>
.cont {
  font-family: "Lato", sans-serif;
  font-weight: 400;
  padding: 2px;
}
</style>
